import {default as Component} from './StripeCardForm'
import {addPaymentMethod} from '../../redux/endpointActions';
import {ACTION_TYPE} from '../../redux/types'
import {connect} from 'react-redux'

const servicePath = 'user/account/payment'

const getPaymentToken = (dispatch, addPaymentMethod) => (
    (stripe, element) => {
        dispatch({type: ACTION_TYPE.GET_PAYMENT_TOKEN_REQUEST})
        stripe.createToken(element).then(
            result => {
                if (result.token) {
                    dispatch({type: ACTION_TYPE.GET_PAYMENT_TOKEN_RESPONSE, body: result})
                    addPaymentMethod(result.token.card.id)(dispatch)
                } else {
                    dispatch({
                        type: ACTION_TYPE.GET_PAYMENT_TOKEN_RESPONSE_FAIL,
                        body: {errorMessage: result.error.message}
                    })
                }
                element.clear()
            })
    }
)

const StripeCardForm = connect(
    (state) => ({
        disabled: state.paymentMethod.disabled,
        err: state.paymentMethod.err,
        addPaymentMethod: (state.login.isLoggedIn ? addPaymentMethod(process.env.REACT_APP_SERVICE_ENDPOINT + servicePath, state.login.userToken.AuthenticationResult.AccessToken, state.login.userToken.AuthenticationResult.IdToken) : () => (() => {
        })),
        getPaymentToken: (state.login.isLoggedIn ? getPaymentToken : () => (() => {
        }))
    }),
    (dispatch) => ({
        dispatch: dispatch
    }),
    (stateProps, dispatcherProps) => ({
        disabled: stateProps.disabled,
        err: stateProps.err,
        stripeApiKey: process.env.REACT_APP_STRIPE_API_KEY,
        addPaymentMethod: stateProps.getPaymentToken(dispatcherProps.dispatch, stateProps.addPaymentMethod)
    })
)(Component)

StripeCardForm.defaultProps = {
    disabled: null,
    addPaymentMethod: null,
    stripeElementType: null,
    stripeElementStyle: null,
}

export default StripeCardForm  


// WEBPACK FOOTER //
// ./src/components/StripeCardForm/index.js